import { FETCH_PRICES, LOG_ANONYMOUS_ERROR } from "./actions";

const defaultState: any = {
  currencySymbol: "$",
  prices: [
    { price: 0, taxAmount: 0 },
    { price: 10, taxAmount: 0 },
    { price: 25, taxAmount: 0 },
    { price: 60, taxAmount: 0 }
  ],
  hasTax: false,
};

const getPricesForCurrency = (data: any) => {
  const { pricingPlans, userBillingCurrencyId, hasTax } = data;

  // Extract prices for the given userBillingCurrencyId
  const prices = pricingPlans.map(plan => {
    const currency = plan.currencyCostPerMonth.find(
      cost => cost.currencyId === userBillingCurrencyId
    );
    return { price: currency ? currency.price : null, taxAmount: currency && hasTax ? currency.taxAmount : null }; // Return the price or null if not found
  });

  return prices.filter(price => price.price !== null); // Filter out null values
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_PRICES + "_FULFILLED": {
      const prices = getPricesForCurrency(action.payload.data);
      return {
        ...state,
        prices: prices,
        currencySymbol: action.payload.data.currencySymbol,
        hasTax: action.payload.data.hasTax
      };
    }

    case LOG_ANONYMOUS_ERROR + "_PENDING": {
      return {
        ...state,
        loading: true
      };
    }

    case LOG_ANONYMOUS_ERROR + "_FULFILLED": {
      return {
        ...state,
        loading: false
      }
    }

    case LOG_ANONYMOUS_ERROR + "_REJECTED": {
      return {
        ...state,
        loading: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
